import { render, staticRenderFns } from "./Table-all.vue?vue&type=template&id=682daa0c&"
import script from "./Table-all.vue?vue&type=script&lang=js&"
export * from "./Table-all.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports